var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSunBigCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32C0 14.3269 14.3269 0 32 0V0C49.6731 0 64 14.3269 64 32V32C64 49.6731 49.6731 64 32 64V64C14.3269 64 0 49.6731 0 32V32Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0002 27.0352V20.0002H36.9652L32.0002 15.0352L27.0352 20.0002H20.0002V27.0352L15.0352 32.0002L20.0002 36.9652V44.0002H27.0352L32.0002 48.9652L36.9652 44.0002H44.0002V36.9652L48.9652 32.0002L44.0002 27.0352ZM41.0002 35.7202V41.0002H35.7202L32.0002 44.7202L28.2802 41.0002H23.0002V35.7202L19.2802 32.0002L23.0002 28.2802V23.0002H28.2802L32.0002 19.2802L35.7202 23.0002H41.0002V28.2802L44.7202 32.0002L41.0002 35.7202ZM32.0002 23.7502C27.4552 23.7502 23.7502 27.4552 23.7502 32.0002C23.7502 36.5452 27.4552 40.2502 32.0002 40.2502C36.5452 40.2502 40.2502 36.5452 40.2502 32.0002C40.2502 27.4552 36.5452 23.7502 32.0002 23.7502ZM32.0002 37.2502C29.1052 37.2502 26.7502 34.8952 26.7502 32.0002C26.7502 29.1052 29.1052 26.7502 32.0002 26.7502C34.8952 26.7502 37.2502 29.1052 37.2502 32.0002C37.2502 34.8952 34.8952 37.2502 32.0002 37.2502Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 35C33.6569 35 35 33.6569 35 32C35 30.3431 33.6569 29 32 29C30.3431 29 29 30.3431 29 32C29 33.6569 30.3431 35 32 35Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSunBigCircle);
export default __webpack_public_path__ + "static/media/ic_sun_big_circle.78a8266110975b1472c82d6033406e91.svg";
export { ForwardRef as ReactComponent };